module.exports = __webpack_public_path__ + "img/logo.16576c73.png";